/**
 * Tracking-Utility für FotoboxGuru Wizard
 * Sendet Events an Google Tag Manager mit guru_ Präfix
 */

const pushToDataLayer = (eventData) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    // Debug: Event in Console loggen
    console.log("🎯 Guru Tracking:", eventData.event, eventData);
  }
};

const trackVirtualPageView = (pagePath) => {
  pushToDataLayer({
    event: "virtualPageview",
    pagePath: pagePath,
  });
};

const getWizardStepPath = (step, wizardData = {}, isResults = false) => {
  if (isResults) return "/fotobox-finder/results";

  switch (step) {
    case 1:
      return "/fotobox-finder/eventtype";
    case 2:
      return "/fotobox-finder/printtype";
    case 3:
      return wizardData?.printType === "print"
        ? "/fotobox-finder/flatrate"
        : "/fotobox-finder/extras";
    case 4:
      return wizardData?.printType === "print"
        ? "/fotobox-finder/guestcount"
        : "/fotobox-finder/digital";
    case 5:
      return wizardData?.printType === "print"
        ? "/fotobox-finder/extras"
        : "/fotobox-finder/delivery";
    case 6:
      return wizardData?.printType === "print"
        ? "/fotobox-finder/digital"
        : wizardData?.delivery === "regional"
        ? "/fotobox-finder/postalcode"
        : "/fotobox-finder/results";
    case 7:
      return wizardData?.printType === "print"
        ? "/fotobox-finder/delivery"
        : "/fotobox-finder/results";
    case 8:
      return "/fotobox-finder/postalcode";
    default:
      return "/fotobox-finder";
  }
};

export const trackWizardEvent = {
  pageViewed: ({ step, wizardData, isResults = false }) => {
    const pagePath = getWizardStepPath(step, wizardData, isResults);
    trackVirtualPageView(pagePath);
  },

  // Step 1: EventType
  eventTypeSelected: (eventType) => {
    pushToDataLayer({
      event: "guru_eventtype_selected",
      guru_eventtype: eventType,
    });
  },

  // Step 2: PrintType
  printTypeSelected: (printType) => {
    pushToDataLayer({
      event: "guru_printtype_selected",
      guru_printtype: printType, // "print" oder "digital"
    });
  },

  // Step 3: Flatrate (nur bei Print)
  flatrateSelected: (wantsFlatrate) => {
    pushToDataLayer({
      event: "guru_flatrate_selected",
      guru_flatrate: wantsFlatrate ? "with" : "without",
    });
  },

  // Step 4: Gästezahl (nur bei Print)
  guestCountSelected: (guestCount) => {
    pushToDataLayer({
      event: "guru_guestcount_selected",
      guru_guestcount: guestCount,
    });
  },

  // Step 5: Extras
  extrasSelected: (extras) => {
    pushToDataLayer({
      event: "guru_extras_selected",
      guru_extras: extras.join(",") || "none",
      guru_extras_props: extras.includes("props"),
      guru_extras_liveview: extras.includes("liveview"),
    });
  },

  // Step 6: Digital Options
  digitalSelected: (digitalOptions) => {
    pushToDataLayer({
      event: "guru_digital_selected",
      guru_digital: digitalOptions.join(",") || "none",
      guru_digital_handy: digitalOptions.includes("handy"),
      guru_digital_gallery: digitalOptions.includes("gallery"),
      guru_digital_usb: digitalOptions.includes("usb"),
    });
  },

  // Step 7: Delivery
  deliverySelected: (delivery) => {
    pushToDataLayer({
      event: "guru_delivery_selected",
      guru_delivery: delivery, // "regional" oder "shipping"
    });
  },

  // Step 8: PLZ (nur bei Regional)
  postalCodeEntered: (postalCode) => {
    pushToDataLayer({
      event: "guru_postalcode_entered",
      guru_postalcode: postalCode,
    });
  },

  // Ergebnisse angezeigt - feuert separate Events pro Partner
  resultsShown: (products, wizardData) => {
    // Gesamtübersicht
    pushToDataLayer({
      event: "guru_results_overview",
      guru_results_count: products.length,
      guru_eventtype: wizardData?.eventType,
      guru_printtype: wizardData?.printType,
      guru_delivery: wizardData?.delivery,
    });

    // Separates Event pro Partner (Top 3)
    products.slice(0, 3).forEach((product, index) => {
      const partnerName = product.partnername || product.name || "Unknown";
      pushToDataLayer({
        event: "guru_result_shown",
        guru_partner_name: partnerName,
        guru_position: index + 1,
        guru_eventtype: wizardData?.eventType,
        guru_printtype: wizardData?.printType,
        guru_delivery: wizardData?.delivery,
        guru_total_price: product.totalPrice,
      });
    });
  },

  // Wizard komplett abgeschlossen
  wizardCompleted: (wizardData) => {
    pushToDataLayer({
      event: "guru_wizard_completed",
      guru_complete_eventtype: wizardData.eventType,
      guru_complete_printtype: wizardData.printType,
      guru_complete_delivery: wizardData.delivery,
    });
  },
};
